function flattenEntries(entries = []) {
  return entries.flatMap(entry => {
    if (entry?.type === 'section' && Array.isArray(entry.items)) {
      return entry.items.filter(item => Boolean(item?.to));
    }

    return entry?.type === 'link' && entry.to ? [entry] : [];
  });
}

function scoreModuleEntry(entry) {
  const label = `${entry?.label || ''}`.toLowerCase();
  const path = `${entry?.to || ''}`.toLowerCase();

  if (label.includes('dashboard') || path.endsWith('/dashboard')) {
    return 100;
  }

  if (label.includes('tablero')) {
    return 95;
  }

  if (label.includes('panel')) {
    return 90;
  }

  if (label.includes('vision general') || label.includes('visi\u00f3n general')) {
    return 85;
  }

  if (path.split('/').filter(Boolean).length === 1) {
    return 80;
  }

  return 0;
}

const FIXED_MODULE_LANDING_ROUTES = {
  Cargas: '/cargas/dashboard',
  'Administración': '/administracion',
};

export function getModuleLandingRoute(entriesOrModuleName, maybeEntries = []) {
  const moduleName = Array.isArray(entriesOrModuleName) ? null : entriesOrModuleName;
  const entries = Array.isArray(entriesOrModuleName) ? entriesOrModuleName : maybeEntries;
  const links = flattenEntries(entries);

  if (moduleName && FIXED_MODULE_LANDING_ROUTES[moduleName]) {
    return FIXED_MODULE_LANDING_ROUTES[moduleName];
  }

  if (!links.length) {
    return '/';
  }

  const preferred = [...links].sort((a, b) => scoreModuleEntry(b) - scoreModuleEntry(a))[0];
  return preferred?.to || links[0]?.to || '/';
}
